//The admin has lots of simple lists, so one generic "set this branch" action keeps the boilerplate down
export const SET_BRANCH = "admin/SET_BRANCH";
export const SET_FILTERS = "admin/SET_FILTERS";
